// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3ng1j","large":"styles_large__sI-nG"};